module.exports = __webpack_public_path__ + "img/inflable-body.3038c705.svg";